module.exports = __webpack_public_path__ + "img/c08_unittechjuggernautchampion_Normal_ua.4223b475.webp";